import { PjesaLigjerates } from '@core/enums/pjesa-ligjerates.enum';
import { Constants } from '@core/globals/constants';
import { QueryBuilderConfig } from 'ngx-angular-query-builder';

export class QueryBuilderConfigs {
  private static get Nyja() {
    const nyja = Constants.Nyja.map<{ name: string; value: any }>((x) => {
      return { name: x.long, value: x.id };
    });
    nyja.unshift({ name: 'empty', value: null });
    return nyja;
  }

  public static Config: QueryBuilderConfig = {
    fields: {
      headWord: {
        name: 'headword',
        type: 'string',
        operators: ['startswith', 'not_startswith', 'contains_word', 'not_contains_word', 'contains', 'not_contains', 'endswith', 'not_endswith'],
        defaultValue: () => {
          return {
            value: '',
          };
        },
        validator: (rule, parent) => {
          return rule.value.value == '' ? false : null;
        },
      },
      node: {
        name: 'node',
        type: 'category',
        operators: ['=', '!='],
        options: this.Nyja,
        defaultValue: () => {
          return this.Nyja[0];
        },
      },
      homonym: {
        name: 'homonym',
        type: 'category',
        operators: ['=', '!=', '>', '>=', '<', '<='],
        options: Constants.Homonimet.map((x) => {
          return { name: x.long, value: x.id };
        }),
        defaultValue: () => {
          return {
            value: '',
          };
        },
      },
      partOfSpeech: {
        name: 'partofspeech',
        type: 'partOfSpeech',
        operators: ['=', '!='],
        options: [
          { name: 'Zbrazët', value: 0 },
          { name: 'Emër (em.)', value: PjesaLigjerates.Emer },
          { name: 'Mbiemër (mb.)', value: PjesaLigjerates.Mbiemer },
          { name: 'Numëror (num.)', value: PjesaLigjerates.Numeror },
          { name: 'Përemër (për.)', value: PjesaLigjerates.Peremer },
          { name: 'Folje (fol.)', value: PjesaLigjerates.Folje },
          { name: 'Ndajfolje (ndjf.)', value: PjesaLigjerates.Ndajfolje },
          { name: 'Parafjalë (prf.)', value: PjesaLigjerates.Parafjale },
          { name: 'Lidhëz (ldhz.)', value: PjesaLigjerates.Lidhez },
          { name: 'Pjesëz (pj.)', value: PjesaLigjerates.Pjesez },
          { name: 'Pasthirrmë (psth.)', value: PjesaLigjerates.Pasthirrme },
          { name: 'E papërcaktuar (papërcak.)', value: PjesaLigjerates.Epapercaktuar },
        ],
        defaultValue: () => {
          return {
            pjesaLigjerates: null,
            filteri: [],
            subFilteri: null
          };
        },
        validator: (rule, parent) => {
          return rule.value.pjesaLigjerates == null ? false : null;
        },
      },
      approval: {
        name: 'approval',
        operators: ['in', 'not_in'],
        type: 'multiselectAutosuggest',
        options: [], //loaded async
        defaultValue: () => {
          return {
            values: [],
          };
        },
        validator: (rule, parent) => {
          return rule.value.values.length == 0 ? false : null;
        },
      },
      lex_approval: {
        name: 'lex_approval',
        operators: ['in', 'not_in'],
        type: 'multiselectAutosuggest',
        options: [], //loaded async
        defaultValue: () => {
          return {
            values: [],
          };
        },
        validator: (rule, parent) => {
          return rule.value.values.length == 0 ? false : null;
        },
      },
      source: {
        name: 'source',
        operators: ['in', 'not_in'],
        type: 'multiselectAutosuggest',
        options: [], // loaded async
        defaultValue: () => {
          return {
            values: [],
          };
        },
        validator: (rule, parent) => {
          return rule.value.values.length == 0 ? false : null;
        },
      },
      reference: {
        name: 'reference',
        operators: [
          'empty',
          'not_empty',
          'startswith',
          'not_startswith',
          'contains_word',
          'not_contains_word',
          'contains',
          'not_contains',
          'endswith',
          'not_endswith',
        ],
        type: 'reference',
        defaultValue: () => {
          return {
            referenceTitle: '',
            referenceURL: '',
          };
        },
        validator: (rule, parent) => {
          return !['empty', 'not_empty'].includes(rule?.operator!) && rule.value.referenceTitle == '' && rule.value.referenceDescription == '' ? false : null;
        },
      },
      insertDate: {
        name: 'insertdate',
        type: 'date',
        defaultValue: () => {
          return {
            value: '',
          };
        },
        validator: (rule, parent) => {
          if (rule.value.value == '') return 'querybuilder_validator_insertdate_empty';
          else if (isNaN(Date.parse(rule.value.value))) return 'querybuilder_validator_insertdate_invalid';
          else return null;
        },
      },
      updateDate: {
        name: 'updatedate',
        type: 'date',
        defaultValue: () => {
          return {
            value: '',
          };
        },
        validator: (rule, parent) => {
          if (rule.value.value == '') return 'querybuilder_validator_updatedate_empty';
          else if (isNaN(Date.parse(rule.value.value))) return 'querybuilder_validator_updatedate_invalid';
          else return null;
        },
      },
      comments: {
        name: 'comments',
        operators: ['empty', 'not_empty', 'contains', 'not_contains', 'has_commented'],
        type: 'comments',
        options: [], // loaded async
        defaultOperator: 'has_commented',
        defaultValue: () => {
          return {
            value: '',
          };
        },
        validator: (rule, parent) => {
          return ['contains', 'not_contains', 'has_commented'].includes(rule?.operator!) && rule.value.value == '' ? false : null;
        },
      },
      manual: {
        name: 'manual',
        type: 'boolean',
        operators: ['='],
        defaultValue: () => {
          return {
            value: false
          }
        },
      },
    },
    allowEmptyRulesets: false,
  };
}
